import {
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from "@mui/material";
import {
  SEND_EMAIL_TEMPLATE_FIELDS,
} from "./emailAllFields";
import useStyles from "../../../components/common/model/styles";
import FormField from "../../../components/common/FormField";
import Notification from "../../../components/common/notification/Notification";
import Popup from "../../../components/common/model/Popup";
import CLOSE_ICON from "../../../assets/closeModel.png";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  emailSendLocalState,
  resetNewEmailSendLocal,
  sendEmailTemplateAction,
  sendEmailTemplateResponseAction,
  setNewEmailSendLocal,
} from "../../../store/reducers/emailTemplateSlice";
import { useSelector } from "react-redux";
import Validation from "../../../utils/Validation";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import { getAllTelnetAction } from "../../../store/reducers/adminClientsSlice";
import CustomButton from "../../../components/common/button/CustomButton";
interface ManageSendEmailTemplateProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectTemplate?: any; // Adjust type as per your requirement
  setSelectedRow?: any; // Adjust type as per your requirement
  screenType?: "ADMIN" | "CLIENT"; // Add screenType prop
}

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  search: string;
}

const ManageSendEmailTemplate = (props: ManageSendEmailTemplateProps) => {
  const { selectTemplate, setSelectedRow, onHide, open, title, screenType } =
    props;

  const {
    allEvents,
    newEmailSendLocal,
    isAddEmailTemplateSuccess,
    isSendEmailResponse,
  } = useSelector((state: any) => state.emailTemplates);

  const classes = useStyles();
  const dispatch = useDispatch();
  const [emailType, setEmailType] = useState<"single" | "bulk">("single");
  const { clients } = useSelector((state: any) => state.adminClients);

  const [isReset, setIsReset] = useState(false);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    to: newEmailSendLocal?.emailSend?.to,
    cc: newEmailSendLocal?.emailSend?.cc,
    bcc: newEmailSendLocal?.emailSend?.bcc,
    subject: newEmailSendLocal?.emailSend?.subject,
    body: newEmailSendLocal?.emailSend?.body,
  });

  const [fullWidth, setFullWidth] = useState(true);
  const [isActionCalled, setIsActionCalled] = useState(false);
  // Store original body with placeholders
  const [templateBody, setTemplateBody] = useState<string>(
    newEmailSendLocal?.emailSend?.body || ""
  );
  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 1000,
    orderBy: "created_at",
    orderIn: "DESC",
    search: "",
  });

  useEffect(() => {
    if (dispatch) {
      dispatch(getAllTelnetAction(filterOption));
    }
  }, [dispatch, filterOption]);

  useEffect(() => {
    if (isSendEmailResponse) {
      hideHandler();
      dispatch(sendEmailTemplateResponseAction(false));
    }
  }, [isSendEmailResponse]);

  useEffect(() => {
    if (selectTemplate?.body) {
      setTemplateBody(selectTemplate.body); // keep placeholder template
    }
  }, [selectTemplate]);

  useEffect(() => {
    if (selectTemplate) {
      dispatch(
        setNewEmailSendLocal({
          emailSend: {
            ...newEmailSendLocal?.emailSend,
            ...selectTemplate,
            templateId: selectTemplate?.template_id,
          },
        })
      );
    }
  }, [selectTemplate]);

  // Replace placeholder tags in body text
  const replaceClientPlaceholders = (bodyText: string, client: any) => {
    if (!bodyText) return bodyText;

    // Define all placeholders you want to support
    const replacements: Record<string, string> = {
      "{{client_name}}": client.company || "",
      "{{email}}": client.email || "",
      "{{client_id}}": client.client_id || "",
      "{{phone}}": client.phone_number || "",
      "{{username}}": client.username || "",
    };

    // Replace all placeholders in the body
    let updatedBody = bodyText;
    Object.keys(replacements).forEach((key) => {
      const regex = new RegExp(key, "gi"); // case-insensitive replace
      updatedBody = updatedBody.replace(regex, replacements[key]);
    });

    return updatedBody;
  };

  const eventNames = allEvents.map((event: any) => event);

  const onChangeAction = (event: any) => {
    if (isReset) {
      return;
    }
    const { id, value, type, name } = event.target;
    const key = type === "radio" ? name : id;
    const updatedEmailTemplate = {
      ...newEmailSendLocal?.emailSend,
      [key]: value,
    };

    // ✅ Replace placeholders only when client changes
    if (key === "to" && value && emailType === "single") {
      const selectedClient = clients.find((c: any) => c.phone_number === value);
      if (selectedClient) {
        updatedEmailTemplate.body = replaceClientPlaceholders(
          templateBody,
          selectedClient
        );
      }
    }
    // For bulk email, always use original template body
    if (emailType === "bulk") {
      updatedEmailTemplate.body = templateBody;
    }
    dispatch(setNewEmailSendLocal({ emailSend: updatedEmailTemplate }));
    resetValidator(key);
  };

  useEffect(() => {
  if (emailType === "bulk") {
    // Reset body to original template when switching to bulk
    dispatch(
      setNewEmailSendLocal({
        emailSend: {
          ...newEmailSendLocal?.emailSend,
          body: templateBody,
          to: null, // dummy value
        },
      })
    );
  } else if (emailType === "single") {
    // Optional: reset body to original template when switching back to single
    dispatch(
      setNewEmailSendLocal({
        emailSend: {
          ...newEmailSendLocal?.emailSend,
          body: templateBody,
        },
      })
    );
  }
}, [emailType]);

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    checkValidator(id);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // If bulk, force a dummy "to" value to avoid validation errors
    if (emailType === "bulk") {
      dispatch(
        setNewEmailSendLocal({
          emailSend: {
            ...newEmailSendLocal.emailSend,
            to: "bulk@example.com", // dummy value
          },
        })
      );
    }
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        let payload: any = { ...newEmailSendLocal.emailSend };

        if (emailType === "bulk") {
          // For bulk email:
          payload = {
            ...payload,
            to: null, // dummy value
            send_to_all: true, // mark as bulk send
          };
        } else {
          payload.send_to_all = false; // single email
        }

        dispatch(sendEmailTemplateAction(payload));
      } else {
        console.log("error", error);
      }
      setIsActionCalled(false);
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  const hideHandler = () => {
    dispatch(sendEmailTemplateResponseAction(false));
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    props.onHide();
    setSelectedRow(null);
    setTimeout(() => {
      dispatch(resetNewEmailSendLocal());
    }, 300);
  };

  useEffect(() => {
    if (isAddEmailTemplateSuccess) {
      hideHandler();
    }
  }, [isAddEmailTemplateSuccess]);

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
      setIsClickReset(false);
    }
  }, [isClickReset]);

  const handleClear = () => {
    if (selectTemplate?.template_id) {
      setTimeout(() => {
        dispatch(
          setNewEmailSendLocal({
            templateId: selectTemplate?.template_id,
            emailSend: selectTemplate,
          })
        );
      }, 300);
      dispatch(
        setNewEmailSendLocal({
          emailSend: selectTemplate,
        })
      );
      resetAllValidator();
    } else {
      dispatch(setNewEmailSendLocal(emailSendLocalState));
      setTimeout(() => {
        dispatch(resetNewEmailSendLocal());
      }, 300);
      resetAllValidator();
    }
    setIsReset(false);
  };

  const updateField = SEND_EMAIL_TEMPLATE_FIELDS.map((field) => {
    // ✅ For client dropdown
    if (field?.id === "to") {
      if (emailType === "bulk") {
        return {
          ...field,
          hidden: true, // custom flag to hide field
          value: "bulk@example.com", // dummy value to avoid validation
        };
      } else {
        return {
          ...field,
          options:
            clients?.map((client: any) => ({
              label: client.company, // what to display
              value: client.email, // value to store
            })) || [],
        };
      }
    }
    return field;
  });

  // 🔹 Compute placeholders dynamically based on selected category + event
  const placeholderTagValue =
    eventNames
      ?.find((x: any) => x.category === newEmailSendLocal?.emailSend?.category)
      ?.events?.find(
        (event: any) => event.event_name === newEmailSendLocal?.emailSend?.event
      )?.placeholders || [];

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={"lg"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            {/* <img
              onClick={(e: any) => handleSubmit(e)}
              src={SAVE_ICON}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={RESET_ICON}
              className={classes.deleteicons}
              alt="delete"
            /> */}
            <img
              onClick={hideHandler}
              src={CLOSE_ICON}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            <CustomButton
              style={{ padding: "10px 30px", height: "36px" }}
              title={emailType === "single" ? "Send" : "Send to All"}
              onClick={handleSubmit}
            />
          </>
        }
      >
        <DialogContent>
          <DialogContentText className={classes.formAddBox}>
            <>
              <Grid container spacing={2}>
                {/* <Grid item xs={12} sx={{ padding: "0px" }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, fontWeight: "600" }}
                  >
                    Select Email Type:
                  </Typography>
                  <Grid
                    container
                    spacing={2}
                    sx={{ display: "flex", justifyItems: "center" }}
                  >
                    <Grid item>
                      <input
                        type="radio"
                        id="singleEmail"
                        name="emailType"
                        value="single"
                        checked={emailType === "single"}
                        onChange={() => setEmailType("single")}
                      />
                      <label htmlFor="singleEmail" style={{ marginLeft: 4 }}>
                        Send Single Email
                      </label>
                    </Grid>
                    <Grid item>
                      <input
                        type="radio"
                        id="bulkEmail"
                        name="emailType"
                        value="bulk"
                        checked={emailType === "bulk"}
                        onChange={() => setEmailType("bulk")}
                      />
                      <label htmlFor="bulkEmail" style={{ marginLeft: 4 }}>
                        Send Bulk Email
                      </label>
                    </Grid>
                  </Grid>
                </Grid> */}
                <Grid item xs={12}>
                  <Notification />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Grid container spacing={2}>
                    {updateField
                      ?.filter((field: any) => !field.hidden)
                      .map((field, i) => {
                        if (
                          field.id === "signature" &&
                          newEmailSendLocal?.emailSend?.signature_option !==
                            "custom_signature"
                        ) {
                          return null; // Do not render the signature field if custom_signature is selected
                        }
                        return (
                          <>
                            <Grid
                              item
                              xs={12}
                              md={
                                field?.type === "editor" ||
                                field?.type === "chipText"
                                  ? 12
                                  : 6
                              }
                              key={i}
                              sx={{ padding: "0px 4px" }}
                            >
                              <Grid container spacing={2}>
                                <FormField
                                  key={field.id}
                                  onPaste={(e) =>
                                    field?.id === "subject"
                                      ? ""
                                      : e.preventDefault()
                                  }
                                  onKeyDown={(event: any) => {
                                    setIsReset(false);
                                    console.log(
                                      "event log-",
                                      event,
                                      event.target.value + event.key
                                    );
                                    if (
                                      event.keyCode === 8 ||
                                      event.keyCode === 9 ||
                                      event.keyCode === 37 ||
                                      event.keyCode === 38 ||
                                      event.keyCode === 39 ||
                                      event.keyCode === 40 ||
                                      event.keyCode === 18 ||
                                      event.keyCode === 17 ||
                                      event.ctrlKey
                                    )
                                      return event;
                                    if (
                                      field?.patternAllowed &&
                                      !field?.patternAllowed.test(event.key)
                                    ) {
                                      event.preventDefault();
                                    } else if (
                                      field?.patternAllowed &&
                                      !field?.patternAllowed.test(
                                        event.target.value + event.key
                                      )
                                    ) {
                                      event.preventDefault();
                                    }
                                  }}
                                  {...{
                                    ...field,
                                    placeholderValue: placeholderTagValue,
                                    value: newEmailSendLocal?.emailSend
                                      ? newEmailSendLocal?.emailSend[field?.id]
                                      : "",
                                    ...{
                                      variant: "outlined", // Adding this variant prop
                                      onChange: onChangeAction,
                                      onBlur: onBlurAction,

                                      multiple: false,
                                      InputProps: {
                                        ...(field?.inputProps &&
                                          field?.inputProps),
                                        sx:
                                          field?.type === "text" ||
                                          field?.type === "password"
                                            ? { height: "36px" }
                                            : {
                                                padding: "10px 4px",
                                                height: "36px",
                                              },
                                      },

                                      // error:
                                      //   field?.id === "signature" &&
                                      //   newEmailSendLocal?.emailSend ===
                                      //     "custom_signature" &&
                                      //   isCustomeSignature
                                      //     ? true
                                      //     : error && error[field?.id],
                                      error: error && error[field?.id],
                                      selectedValues:
                                        newEmailSendLocal?.emailSend[field?.id],
                                      // helperText:
                                      //   emailSettingError && emailSettingError[field?.id],
                                    },
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </>
                        );
                      })}
                  </Grid>
                </Grid>
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
    </>
  );
};
export default ManageSendEmailTemplate;
